import { ArrowLeft, Margin } from "@mui/icons-material";
import { Typography, colors, textFieldClasses } from "@mui/material";
import React from "react";
import { useHistory, useLocation } from "react-router";

export default function Logout() {
  
    const history = useHistory();
    const location = useLocation();
    function logOut(){
        localStorage.clear();
        history.push('/')
    }

    return (
        <div className="logout-dropdown ">
          <ul>
            <li onClick={logOut}  
                style={{ cursor: 'pointer' }} 
                >
                    <Typography className="text-color">Déconnexion</Typography>
            </li>
         </ul>
    </div>
    )
}


